import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {CountryService} from "../../services/location/country.service";
import {OverlayPanel} from "primeng/overlaypanel";

@Component({
  selector: 'app-phone-numbers',
  templateUrl: './phone-numbers.component.html',
  styleUrl: './phone-numbers.component.scss'
})
export class PhoneNumbersComponent implements OnInit, OnChanges {
  @ViewChild('op') op: OverlayPanel
  @Output() contactItemsChange = new EventEmitter<any[]>();
  @Input() contacts: any[] = [];
  @Input() type: 'phoneNumbers' | 'emails' | 'relativePhones'  = 'phoneNumbers';

  newContactItem: boolean = true;
  isEditing: any;
  contactItems: Array<any> = [];
  newContactData: any = {
    name: '',
    prefixValue: '+90',
    phone: '',
    relativePhone: '',
    email: '',
    priority: false,
  };
  isValidPhone: boolean = true;
  countries: any[] = [];

  constructor(
    private readonly countryService: CountryService,
  ) {
  }

  ngOnInit(): void {
    this.countryService.getAll().subscribe((res) => {
      if (res.length > 0) {
        this.countries = res.map((item: any) => ({
          name: item.name,
          value: item.phoneCode,
          label: item.phoneCode,
          flag: item.flag
        }));
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["contacts"]?.currentValue) {
      this.contactItems = changes["contacts"].currentValue;
    }
  }

  closeOverlay() {
    this.op.hide();

  }

  reset(): void {
    this.contacts = [{
      name: '',
      prefixValue: '',
      phone: '',
      email: '',
      priority: false,
    }]

    this.newContactData = {
      name: '',
      prefixValue: '',
      phone: '',
      email: '',
      priority: false,
    }
  }

  get iconClass(): string {
    return  (this.type === 'phoneNumbers' || this.type === 'relativePhones')? 'bi bi-telephone-outbound' : 'bi bi-envelope';
  }

  get headerTitle(): string {
    return  (this.type === 'phoneNumbers' || this.type === 'relativePhones') ? 'Telefon Numaraları' : 'E-Posta Adresleri';
  }

  get columnTitle(): string {
    return  (this.type === 'phoneNumbers' || this.type === 'relativePhones') ? 'Telefon Numarası' : 'E-Posta Adresi';
  }

  onPhoneInput(value: string): void {
    this.isValidPhone = /^\d{1,10}$/.test(value);
    if (this.isValidPhone) {
      this.newContactData.phone = value;
    }
  }

  onRelativePhoneInput(value: string): void {
    this.isValidPhone = /^\d{1,10}$/.test(value);
    if (this.isValidPhone) {
      this.newContactData.relativePhone = value;
    }
  }

  onEmailInput(value: string): void {
    this.newContactData.email = value;
  }

  isPhoneValid(): boolean {
    const phone = this.newContactData.phone;
    const phonePattern = /^\d{4,15}$/;
    return phonePattern.test(phone);
  }

  isRelativePhoneValid(): boolean {
    const relativePhone = this.newContactData.relativePhone;
    const phonePattern = /^\d{4,15}$/;
    return phonePattern.test(relativePhone);
  }

  isEmailValid(): boolean {
    const email = this.newContactData.email;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  }

  newHeadItem() {
    this.newContactItem = !this.newContactItem;
    this.newContactData = {
      name: '',
      prefixValue: '',
      relativePhone: '',
      phone: '',
      email: '',
      priority: false
    };
  }

  addContact(newContactData: any) {
    console.log(newContactData)
    this.newContactData = {
      name: '',
      prefixValue: '',
      relativePhone: '',
      phone: '',
      email: '',
      priority: false
    };

    const newContact = {...newContactData, id: Date.now()};  // Geçici ID oluşturuluyor

    if (newContact.priority) {
      this.contactItems = this.contactItems.map(item => ({
        ...item,
        priority: false
      }));
    }

    this.contactItems.push(newContact);

    const contactDataToEmit = this.contactItems.map(contact => {
      const {id, ...rest} = contact;  // geçici 'id' bilgisini çıkarıyoruz
      return rest;  // Sadece gerekli alanları gönderiyoruz
    });

    this.contactItemsChange.emit(contactDataToEmit);  // ID'siz veriyi emit ediyoruz
  }

  saveItem(item: any) {
    const index = this.contactItems.findIndex(i => i.id === item.id);

    if (index !== -1) {
      if (item.priority) {
        this.contactItems = this.contactItems.map((contact, i) => {
          // Güncellenen öğe dışındaki tüm öğelerde priority'yi false yap
          if (i !== index && contact.priority) {
            return {...contact, priority: false};
          }
          return contact;
        });
      }

      this.contactItems[index] = {...item};
      this.contactItemsChange.emit(this.contactItems);
    }

    this.isEditing = null;
  }

  deleteItem(index: number): void {
    console.log('Silinecek item index:', index);
    this.contactItems.splice(index, 1);
    this.contactItemsChange.emit(this.contactItems);
  }

  emitChanges() {
    this.contactItemsChange.emit(this.contactItems);
  }

}
